/**
 *
 */
import { get, post,put,del} from 'mdoc/admin/axios/tools'
import * as config from 'mdoc/admin/axios/config'


//get user
export const getUserInfo = ()=>{
    const _user = JSON.parse(window.localStorage.getItem('user'));
    return _user?_user:null;
}
//get permissions
export const getPermissions = () => {
    const _user = JSON.parse(window.localStorage.getItem('user'));
    return _user?_user.permissions:null;
}

//logout
export const logout = () => {
    window.location = '/admin.html#/login';
    window.localStorage.removeItem('remember');
    window.localStorage.removeItem('user');
    window.localStorage.removeItem('token');
    post(config.ADMIN_LOGOFF).then(response=>{
    });
}

// 文言获取
//param format
const paramFormat = (param)=>{
    let params = [];
    for(let key in param){
        params.push(key);
    }
    return params;
}

export const dictionary = (param) => new Promise((resolve, reject)=> {
    const _localeId = window.localStorage.getItem('localeId');
    post(config.DICTIONARY, {'dictKeyList': (paramFormat(param)),'typeFlg':0}, {
        LANG: parseInt(_localeId),
    }).then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response.docMstLanguage);
            }
        }).catch(function (error) {
            reject(error);
    })
})

export const cnfsystem = (param) => new Promise((resolve, reject)=> {
    get(config.CNFSYSTEM, {'configGroup':'system','configKey': param}).then(
        function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response.configValue);
            }
        }).catch(function (error) {
            reject(error);
    })
})
//langId
export const getlangId = (param) => new Promise((resolve, reject)=> {
    get(config.LANGID, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docMstLocaleList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//企業管理者一覧
export const getEnterprise = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docTblAdminUsers, count: response.count})
            }
        }).catch(function (error) {
            reject(error);
    })
})
//企業管理者一覧削除
export const enterpriseDelete = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISE_DELETE, param)
        .then(function (response) {
            if (response.error) {
                if(response.errorCode === 'E201'){
                    reject(response.errorMessage);
                }else{
                    reject(response.errorMessage);
                }
            }else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//企業管理者登録检查管理者接口
export const getEnterpriseCheck = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISE_POST, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//企業管理者登録企業管理者生成数检查
export const enterpriseCheckNum = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISE_NUM, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})

//パスワードを修正する
export const adminChangePwd = (param) => new Promise((resolve, reject)=> {
    post(config.ADMIN_CHANGE_PWD, param)
        .then(function (response) {
            if (response.error) {
                if(response.errorCode === 'E201'){
                    reject(response.errorMessage);
                }else{
                    reject(response.errorMessage);
                }
            }else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//企業管理者登録checkEmail接口
export const getEnterpriseCheckEmail = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISECHECKEMAIL, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//企業管理者登録
export const EnterpriseLogin = (param,type) => new Promise((resolve, reject)=> {
    if(type === 'put'){
        put(config.ENTERPRISE_POST, param)
            .then(function (response) {
                if (response.error) {
                    reject(response.errorMessage);
                } else {
                    resolve({results: response.docTblAdminUsers})
                }
            }).catch(function (error) {
            reject(error);
        })
    }else {
        post(config.ENTERPRISE_POST, param)
            .then(function (response) {
                if (response.error) {
                    reject(response.errorMessage);
                } else {
                    resolve({results: response.docTblAdminUsers})
                }
            }).catch(function (error) {
                reject(error);
        })
    }
})
//企業管理者详细
export const getEnterpriseDetail = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISEDETAIL, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage)
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
            reject(error);
    })
})
//クライアント
export const getClent = (param) => new Promise((resolve, reject)=> {
    get(config.CLIENTS, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docTblClientList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})

// メモリサイズ
export const clientsInfo = (param) => new Promise((resolve, reject)=> {
    get(config.CLIENTS_INFO, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve(response)
            }
        }).catch(function (error) {
        reject(error);
    })
})
//クライアント详细接口
export const getClentDetail = (id,param) => new Promise((resolve, reject)=> {
    get(config.CLIENTS_DETAIL+id, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//副企業管理者一覧
export const getAssociateEnterprise = (param) => new Promise((resolve, reject)=> {
    get(config.ENTERPRISE, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docTblAdminUsers, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//部署
export const getDepartment = (param) => new Promise((resolve, reject)=> {
    get(config.DEPARTMENT, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docMstDepartmentList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//カテゴリー
export const getCategory = (param) => new Promise((resolve, reject)=> {
    get(config.CATEGORY, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docMstBookCategoryList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//カテゴリーcmb
export const getCategoryCmb = (param) => new Promise((resolve, reject)=> {
    get(config.CATEGORY_GET, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docMstBookCategoryList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//カテゴリーカテゴリcmbAPI
export const getContentCategoryCmb = (param) => new Promise((resolve, reject)=> {
    get(config.CATEGORY_CONTENT, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response.docMstBookCategoryList, count: response.count})
            }
        }).catch(function (error) {
        reject(error);
    })
})
//連携
export const getActiveDirectory = (param) => new Promise((resolve, reject)=> {
    get(config.ACTIVE_DIRECTORY, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response, count: response.count})
            }
        }).catch(function (error) {
            reject(error);
    })
})
//連携追加
export const getActiveDirectoryAdd = (param,type) => new Promise((resolve, reject)=> {
    if(type === 'put'){
        put(config.ACTIVE_DIRECTORY_OPT, param)
            .then(function (response) {
                if (response.error) {
                    reject(response.errorMessage);
                } else {
                    resolve({results: response})
                }
            }).catch(function (error) {
            reject(error);
        })
    }else {
        post(config.ACTIVE_DIRECTORY_OPT, param)
            .then(function (response) {
                if (response.error) {
                    reject(response.errorMessage);
                } else {
                    resolve({results: response})
                }
            }).catch(function (error) {
                reject(error);
        })
    }
})
//連携修正
export const getActiveDirectoryModification = (param) => new Promise((resolve, reject)=> {
    get(config.ACTIVE_DIRECTORY_MODIFICTION, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response, count: response.count})
            }
        }).catch(function (error) {
            reject(error);
    })
})

//接続テスト
export const getActiveDirectoryTest = (param) => new Promise((resolve, reject)=> {
    get(config.ACTIVE_DIRECTORY_TEST, param)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
            reject(error);
    })
})
//連携削除
export const getActiveDirectoryDelete = (id) => new Promise((resolve, reject)=> {
    del(config.ACTIVE_DIRECTORY_OPT+'/'+id)
        .then(function (response) {
            if (response.error) {
                reject(response.errorMessage);
            } else {
                resolve({results: response})
            }
        }).catch(function (error) {
            reject(error);
    })
})